import { MutationCache, QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  mutationCache: new MutationCache({
    onSuccess: async (_data, _vars, _ctx, mutation) => {
      if (mutation.meta?.invalidateQueries === false) {
        return;
      }

      await queryClient.invalidateQueries();
    },
  }),
});
